import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface MarkAsSentDialogProps {
  open: boolean;
  estimateCount: number;
  onConfirm: () => void;
  onSkip: () => void;
}

export function MarkAsSentDialog({ open, estimateCount, onConfirm, onSkip }: MarkAsSentDialogProps) {
  const multi = estimateCount > 1;
  const confirmedRef = useRef(false);

  const handleConfirm = () => {
    confirmedRef.current = true;
    onConfirm();
  };

  const handleSkip = () => {
    confirmedRef.current = true;
    onSkip();
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && !confirmedRef.current) {
      onSkip();
    }
    if (!isOpen) {
      confirmedRef.current = false;
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {multi ? `Mark ${estimateCount} Quotes as Sent?` : "Mark this quote as Sent?"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {multi
              ? `You just exported ${estimateCount} customer PDFs. Would you like to mark all of them as "Sent" to keep your records up to date?`
              : `You just exported a customer PDF. Would you like to mark this quote as "Sent" to keep your records up to date?`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleSkip}>Skip</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>Mark as Sent</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
